import {Injectable} from '@angular/core';
import {BaseService} from "../../../../../../base/services/base.service";
import {AuthService} from "../../../auth/services/auth.service";
import {NotifierService} from "../../../../../../base/services/notifier/notifier.service";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {IWallet} from "../models/wallet.model";
import {IParams} from "../../../../../../base/endpoints/iparams";
import {AccountingEndpoint} from "../../accounting.endpoint";
import {IPage, ResponseData} from "../../../../../../base/models/pagination.model";
import {ITransaction} from "../models/transaction.model";

@Injectable({
  providedIn: 'root'
})
export class WalletService extends BaseService {

  constructor(authService: AuthService,
              notifier: NotifierService,
              private http: HttpClient,
              private eventBus: EventBusService) {
    super(authService, notifier);
  }


  fetchMyWallet(key: string, params: IParams, username: string | null = null) {
    let url = AccountingEndpoint.WALLET.FETCH_MY_WALLET(params)
    this.http.get<ResponseData<IWallet>>(url)
      .subscribe((wallet: ResponseData<IWallet>) => {
        this.eventBus.publish(key, wallet)
      }, (error: HttpErrorResponse) => {
        this.eventBus.publish(key, error)
      })
  }

  fetchWallet(key: string, params: IParams) {
    let url = AccountingEndpoint.WALLET.FETCH_USER_WALLET(params)
    this.http.get<IWallet>(url)
      .subscribe((wallet: IWallet) => {
        this.eventBus.publish(key, wallet)
      }, (error: HttpErrorResponse) => {
        this.eventBus.publish(key, error)
      })
  }

  fetchTransactions(key: string, params: IParams){
    let url = AccountingEndpoint.WALLET.FETCH_TRANSACTIONS(params)
    this.http.get<IPage<ITransaction>>(url)
      .subscribe((transactions: IPage<ITransaction>) => {
        this.eventBus.publish(key, transactions)
      }, (error: HttpErrorResponse) => {
        this.eventBus.publish(key, error)
      })
  }
}
